// Generated by CoffeeScript 2.7.0
var GenerateUserProfile;

export default GenerateUserProfile = {
  _generateUserProfile: (callback) => {
    return Skylark.Libs.Ajax.get(Skylark.Helpers.UrlHelper.namespaceUrlFor("/user_profile/schemas.json"), {
      responseType: 'json',
      success: (profileSchema) => {
        return callback(profileSchema);
      }
    });
  }
};
